import { render, staticRenderFns } from "./supComTabs.vue?vue&type=template&id=33964d87&"
import script from "./supComTabs.vue?vue&type=script&lang=js&"
export * from "./supComTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports